import React from "react";
import { Link } from "react-router-dom";

import Logo from "../../../../../assets/svgs/logos/accessbank-logo.svg";
import footerData from "../../../../../utils/data/footer.json";
import { BiLogoFacebook, BiLogoTwitter, BiLogoInstagram } from "react-icons/bi";
import { AiFillLinkedin } from "react-icons/ai";
import { RiSendPlaneLine } from "react-icons/ri";
import Fade from "react-reveal/Fade";

// Transform links to objects with 'name' and 'link' properties
const data = footerData.footerData.map((section) => ({
  header: section.header,
  links: section.links.map((link) => ({
    name: link,
    link: link.toLowerCase().replace(/[^a-zA-Z0-9]/g, "-"),
  })),
}));

const Footer = ({
  bgColor,
  textColor,
  logo,
  socialLinks,
  logoTextColor,
  placeholderColor,
  inputIconColor,
  hoverColor,
}) => {
  return (
    <footer className={``}>
      <Fade bottom>
        <div className="pt-4 px-16 flex flex-wrap  border-t border-gray-200 container mx-auto items-center justify-between">
          <div className=" flex justify-center items-center mb-6 lg:mb-0">
            <Link to="/corporate">
              <img className="w-20 h-auto" src={logo} alt="quiz-logo" />
            </Link>
          </div>

          <div
            className={`flex items-center text-4xl space-x-10 mb-6 lg:mb-0  ${logoTextColor} `}
          >
            {socialLinks?.map((link, index) => (
              <Link
                key={index}
                to={link?.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link?.icon}
              </Link>
            ))}

            {/* <Link
              to="https://x.com/myaccessbank?t=IO5sr-1V2aHtKwsQXmhgwA&s=09"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accessOrange"
            >
              {" "}
              <BiLogoTwitter className="cursor-pointer" />
            </Link>
            <Link
              to="https://www.facebook.com/AccessBankPlc "
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accessOrange"
            >
              {" "}
              <BiLogoFacebook className="cursor-pointer" />
            </Link>
            <Link
              to="https://www.linkedin.com/company/access-bank-plc/ "
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accessOrange"
            >
              {" "}
              <AiFillLinkedin />{" "}
            </Link> */}
          </div>
          <div className="flex flex-wrap  gap-x-8 items-center">
            <div className="relative mb-6 md:mb-0 ">
              <input
                className={`appearance-none border-2  border-gray-300 hover:border-gray-400 transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none ${placeholderColor} `}
                id="email"
                type="email"
                placeholder="Email"
              />
              <div className="absolute right-0 inset-y-0 flex items-center">
                <RiSendPlaneLine
                  className={`-ml-1 mr-3 h-5 w-5 ${inputIconColor} ${hoverColor} `}
                />
              </div>
            </div>
            <div>
              <p className="font-normal text-lg">
                Subscribe to our newsletter!
              </p>
            </div>
          </div>
        </div>
        <div className="text-center text-gray-600 dark:text-gray-200 py-4 sm:py-6 font-light flex items-center justify-center">
          Qwizfun powered by 9ijakids
        </div>
      </Fade>
    </footer>
  );
};

export default Footer;
